const ONBOARDING_PAGE = {
  BOTI_INTRO: 'botiIntro',
  PROGRESS_INDICATION_1: 'progressIndication1',
  PROGRESS_INDICATION_2: 'progressIndication2',
  SECURITY_INFORMATION: 'securityInformation',
  BANK_SELECTION: 'bankSelection',
  ACCOUNT_INVESTIGATION: 'accountInvestigation',
  INCOME_INVESTIGATION: 'incomeInvestigation',
  CREDIT_CARD_DETAILS: 'creditCardDetails',
  EXPENSE_INVESTIGATION: 'expenseInvestigation',
  CASHFLOW_LOADER: 'cashflowLoader',
  CASHFLOW: 'cashflow',
};

export default {
  ONBOARDING_PAGE,
};



// WEBPACK FOOTER //
// ./src/constants/onboarding-state.js